"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapAzureOperation = wrapAzureOperation;
/**
 * @author Siglud <siglud@gmail.com>
 */
const storage_blob_1 = require("@azure/storage-blob");
const commonConstant_1 = require("../constant/commonConstant");
function isAzureRestError(error) {
    return error instanceof storage_blob_1.RestError || error.hasOwnProperty("statusCode");
}
function isAzureRemoteServerError(error) {
    return (isAzureRestError(error) &&
        (error?.statusCode ?? commonConstant_1.HttpStatusCode.ACCEPTED) >= commonConstant_1.HttpStatusCode.INTERNAL_SERVER_ERROR);
}
async function wrapAzureOperation(operation, remoteErrorHandler, otherErrorHandler) {
    try {
        return await operation();
    }
    catch (error) {
        if (isAzureRemoteServerError(error)) {
            throw remoteErrorHandler(error);
        }
        throw otherErrorHandler(error);
    }
}
//# sourceMappingURL=azureSdkErrorHandler.js.map